import React from "react";
import { usePermissions } from "react-admin";
import { MultiLevelMenu } from "@react-admin/ra-navigation";

import { filterByPermissions } from "../security/utils";
import { resources, settings } from "../../app";

const BuildSubMenu = ({ resource, parentPath }) => {
  const menuStyle = settings.menuStyle && settings.menuStyle();

  const path = settings.useBreadcrumb ? `${parentPath ? `${parentPath}.` : ""}${resource.name}` : resource.name;

  const itemStyle = menuStyle?.MultiLevelMenuItem;
  const subItemStyle = menuStyle?.MultiLevelMenuSubItem;

  const childrenItems =
    resource.subMenu &&
    resource.subMenu
      .filter(subResource => subResource.isMenu)
      .filter(resources => resources.tenancies === undefined || resources.tenancies.includes(settings.tenant))
      .map((subResource, i) => (
        <BuildSubMenu
          key={subResource.name + i}
          parentPath={path}
          resource={subResource}
        />
      ));

  if (resource.subMenu && childrenItems.length === 0) {
    return null;
  }

  return (
    <MultiLevelMenu.Item
      key={resource.title + resource.name}
      name={resource.name + resource.title}
      to={resource.subMenu ? null : path}
      end={resource.exactMenuMatch}
      label={resource.menuLabel ?? resource.title}
      icon={resource.icon}
      sx={resource.subMenu ? itemStyle : subItemStyle}
    >
      {childrenItems}
    </MultiLevelMenu.Item>
  );
};

const Menu = () => {
  const menuStyle = settings.menuStyle ? settings.menuStyle() : null;

  const { permissions } = usePermissions();

  const menuItems = filterByPermissions(resources, permissions)
    .filter(resource => resource.isMenu)
    .filter(resources => resources.tenancies === undefined || resources.tenancies.includes(settings.tenant));

  return (
    <MultiLevelMenu sx={menuStyle?.MultiLevelMenu}>
      {menuItems.map((resource, i) => (
        <BuildSubMenu
          resource={resource}
          key={resource.name + i}
        />
      ))}
    </MultiLevelMenu>
  );
};

export default Menu;
